import { useRouter } from "next/router";
import React, { useContext, useState, useTransition } from "react";
import { useForm } from 'react-hook-form'
import reasonsModel from "../../models/reasons.model";
import Heading from "../../components/Heading";
import helper from "../../lib/helper";
import _ from "lodash";
const Page = function () {
    const router = useRouter()

    const [showLoader, setShowLoader] = useState(false);
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        formState: { errors,isSubmitting },
        setError
    } = useForm();
    const onSubmit = handleSubmit(async (data, event) => {
        const formData = new FormData(event.target);
        console.log(formData.get('type'))
        await reasonsModel.create(formData).then((response) => {
            helper.sweetalert.toast(response.data?.message);
            router.push('/reasons')
        }).catch((error) => {
            helper.sweetalert.toast(error.response.data?.message, 'error');
            _.each(error.response?.data?.errors, function (err, errorKey) {
                setError(errorKey, { type: "required", message: err });
            });
        });
    })


    return (
        <>
            <Heading title=" Create Reason " showLoader={showLoader} />
            <form onSubmit={onSubmit} className="container-fluid">
                <div className="card col-md-12">
                    <div className="card-header">Create Reason</div>
                    <div className="card-body row">
                        <div className="col-md-6 mb-2">
                            <label className="form-label">Type</label>
                            <select className={`form-select ${errors?.type && "is-invalid"}`}
                                {...register("type", {
                                    required: "Type is required",
                                })} >
                                <option value='admin'>Admin</option>
                                <option value='customer'>Customer</option>
                                
                            </select>
                            <div className="invalid-feedback">
                                {errors.type && errors.type.message}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Reason</label>
                            <input
                                type="text"
                                placeholder="Enter cancellation reason"
                                className={`form-control ${errors?.reason && "is-invalid"}`}
                                {...register("reason", {
                                    required: "Reason is required",
                                })}
                            />
                        </div>
                    </div>
                    <div className="card-footer">
                        <button type="submit" disabled={isSubmitting ? 'disabled' : ''} className="btn btn-primary float-end">
                            Save
                        </button>
                    </div>
                </div>
            </form>
        </>
    );



};

export default Page;